import apiClient from "./api";

export interface Sugar {
  id?: number;
  name: string;
  code?: string;
  description?: string;
  status?: boolean | number;
}

export const sugarService = {
  async getSugars(): Promise<Sugar[]> {
    const response = await apiClient.get("/sugar");
    return response.data;
  },

  async getSugar(id: number): Promise<Sugar> {
    const response = await apiClient.get(`/sugar/${id}`);
    return response.data;
  },

  async createSugar(sugar: Sugar): Promise<Sugar> {
    const response = await apiClient.post("/sugar", sugar);
    return response.data.data;
  },

  async updateSugar(id: number, sugar: Partial<Sugar>): Promise<Sugar> {
    const response = await apiClient.put(`/sugar/${id}`, sugar);
    return response.data.data;
  },

  async deleteSugar(id: number): Promise<void> {
    await apiClient.delete(`/sugar/${id}`);
  },
};
